/**
 * @deprecated use: ApiSuccessIndicationEnum
 */
export enum IndicationEnum {
    Yes = 'J',
    No = 'N',
}
